import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWebHistoryItem } from '../../models/web-history.response';
import { SLICE_NAMES } from '../constants';

interface IWebHistoryState {
  loading: boolean;
  hasLoaded: boolean;
  hasError: boolean;
  webHistoryItems: IWebHistoryItem[];
}

const initialState: IWebHistoryState = {
  loading: false,
  hasLoaded: false,
  hasError: false,
  webHistoryItems: [],
};

const webHistorySlice = createSlice({
  name: SLICE_NAMES.WEB_HISTORY,
  initialState,
  reducers: {
    setWebHistoryLoading: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        loading: action.payload,
        hasError: action.payload ? false : state.hasError,
      };
    },
    setWebHistory: (state, action: PayloadAction<IWebHistoryItem[]>) => {
      return {
        ...state,
        hasLoaded: true,
        hasError: false,
        webHistoryItems: action.payload,
      };
    },
    setWebHistoryError: state => {
      return { ...state, hasLoaded: true, hasError: true, webHistoryItems: [] };
    },
    clearWebHistory: () => initialState,
  },
});

export const {
  setWebHistoryLoading,
  setWebHistory,
  setWebHistoryError,
  clearWebHistory,
} = webHistorySlice.actions;

export const webHistoryReducer = webHistorySlice.reducer;
